import { IonContent, 
         IonPage, 
         IonButton, 
         IonButtons, 
         IonFooter,
         IonImg, 
         IonGrid, 
         IonIcon,
         IonRow, 
         IonCol, 
         IonAlert, 
         IonItem, 
         IonLabel, 
         IonInput, 
         IonCheckbox,
         isPlatform } from '@ionic/react';
import { RouteComponentProps, useHistory} from "react-router-dom";
//import { SignInWithApple, AppleSignInResponse, AppleSignInErrorResponse, ASAuthorizationAppleIDRequest } from '@ionic-native/sign-in-with-apple/ngx';

import React, { useState } from 'react';
import axios from 'axios';
//import GoogleLogin from 'react-google-login'; - be sure to remove this application 
import "@codetrix-studio/capacitor-google-auth";
//import { SignInWithApple, AppleSignInResponse, AppleSignInErrorResponse, ASAuthorizationAppleIDRequest } from '@ionic-native/sign-in-with-apple/ngx';
import { Plugins } from '@capacitor/core';
import { set } from '../services/storage.service';
import './Home.css';
import Logo from '../components/Logo';
import { logoGoogle, logoApple } from 'ionicons/icons';
interface ResetProps
    extends RouteComponentProps<{
        message: string;
    }> { }

export interface MyEvent {
    file: string;
}
const plat = isPlatform('iphone');
const ipad = isPlatform('ipad');
const webapp = isPlatform('mobileweb');

function validateEmail(email: string) {
    const re = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
    return re.test(String(email).toLowerCase());
}

function saveToStorage(savetoken:any,saveuser:any,saveemail:any,savenicename:any,saveID:any) {
    if (savetoken) {    
    set("cred", JSON.stringify({ "email": saveemail, "userid": saveID, "nicename": savenicename, "firstname": saveuser,  "authtoken":savetoken}))
    return true;
    }
    return false;
}
const Home: React.FC<ResetProps> = ({ match }) => {
    const history = useHistory();
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>("");
    const [iserror, setIserror] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");

    const [showAgeAlert, setAgeAlert] = useState(false);
    const [showRegAlert, setRegAlert] = useState(false);
    const [showEmailAlert, setEmailAlert] = useState(false);
    const [ThirdParty, setThirdParty ] = useState<string>("");   
 
    const handleThirdParty = (chosen:string) => {
      setThirdParty(chosen);//figure out what third party we are going to use
      console.log(chosen);
      setAgeAlert(true);//bring up the alert
    }

    async function signInWithApple() {
      const {SignInWithApple} = Plugins

      SignInWithApple.Authorize()
      .then((response:any) => {
         //get signed into apple here I guess. 
        let result = response;
        console.log("res",response);
        const email = response.response.user + "@explorermindsetapp.com";
        console.log(email);

        if(response) {
            console.log("res65:",response);
            const id = response.response.user;
            axios.get('https://explorermindsetapp.com/wp-json/appl/v2/check?id='+id,{
            //axios.get('https://expmindapp.wpengine.com/wp-json/appl/v2/check?id='+id,{
            })
            .then(function(response){
              console.log(response);
              let saveID = response['data']['userId'];
                  if (saveID === "nouser"){
                      console.log('create user');
                      let first = 'givenName';
                      let last = 'familyName';
                      let sendemail = ""; 
                      let sendfirst = ""; 
                      let sendlast = "";

                      if(email){sendemail = email;}else{sendemail="";}
                      if(first){sendfirst = first;}else{sendfirst="";}
                      if(last){sendlast = last;}else{sendlast="";}
                      console.log(email,sendemail);
                      //axios.post("http://expmindapp.wpengine.com/wp-json/appl/v2/creator", {
                      axios.post("http://explorermindsetapp.com/wp-json/appl/v2/creator", {
                          id: id,
                          email: sendemail,
                          first_name: sendfirst,
                          last_name: sendlast,
                          imageURL: "",
                      }).then(function(response){
                          console.log(response);
                          
                         // console.log(response.id);
                          console.log("id",id);
                          //now create a token with the Google ID.
                          //axios.get("https://expmindapp.wpengine.com/wp-json/appl/v2/token?id="+id, {//I need some kind of JWT Token
                          axios.get("https://explorermindsetapp.com/wp-json/appl/v2/token?id="+id, {//I need some kind of JWT Token
                          }).then(function(response){
                              let firstname = response['data']['firstName'];
                              console.log(response);
                              //let lastname = response['data']['lastName'];
                              console.log('tokenator');//debug for validating

                              //console.log("response",response);

                              let savetoken = response['data']['token'];
                              let savenicename = response['data']['nicename'];
                              let saveuser = email;
                              let saveemail = email;
                              let saveID = response['data']['claims']['userId'];

                              //console.log("id: " + saveID);

                              if (saveToStorage(savetoken,saveuser,saveemail,savenicename,saveID)) {//save account
                                history.push("/dashboard/" + email);
                              } else {
                                console.log('Failed to store auth');
                              }
                              
                          }).catch(function(error){
                              console.log("error");
                          }).then(function(){
                          });


                          
                      }).catch(function(error){
                          console.log("error");
                      }).then(function(){
                      });
                  }else{
                    console.log("user already exists");
                    let firstname = response['data']['firstName'];
                    console.log(saveID);
                    //let lastname = response['data']['lastName'];
                        //axios.get("https://expmindapp.wpengine.com/wp-json/appl/v2/token?id="+id, {//test site
                      
                        axios.get("https://explorermindsetapp.com/wp-json/appl/v2/token?id="+id, {//live site
                        }).then(function(response){
                            console.log("resp",response);
                            console.log('tokenable');//debug for validating

                            console.log(response['data']['claims'])
                            let savetoken = response['data']['token'];
                            let savenicename = response['data']['nicename'];
                            let saveuser = email;
                            let saveemail = email;
                            let saveID = response['data']['claims']['userId'];

                            console.log("id: " + saveID);
                            if (saveToStorage(savetoken,saveuser,saveemail,savenicename,saveID)) {//save account
                              history.push("/dashboard/" + email);
                            } else {
                              console.log('Failed to store auth');
                            }
                        }).catch(function(error){
                            console.log("error");
                        }).then(function(){
                        });
                  }
              })
              .catch(function (error) {
                  // handle error
                  console.log(error);
              })
              .then(function () {
                  // always executed
              });
        }

      })
      .catch((response:any)=>{
        //console.log(response);
        return(response);
      })
    }
    const signIn = async () => {
      if(ThirdParty === "Apple"){
          //apple action 
          signInWithApple();
      }else{
       try{
        Plugins.GoogleAuth.signOut();
            let result =  await Plugins.GoogleAuth.signIn();
            console.log(result);
            if (result) {
                console.log(result);
                let id = result['id'];
                let email = result['email'];
                //now lets send it to the API
                //axios.get('https://expmindapp.wpengine.com/wp-json/ggle/v2/check?id='+id, {
                axios.get('https://explorermindsetapp.com/wp-json/ggle/v2/check?id='+id, {
                })
                .then(function (response) {
                    // handle success
                    console.log(response);
                    let saveID = response['data']['userId'];
                    if (saveID === "nouser"){
                        console.log('create user');
                        //axios.post("http://expmindapp.wpengine.com/wp-json/ggle/v2/creator", {
                        axios.post("https://explorermindsetapp.com/wp-json/ggle/v2/creator", {
                            id: id,
                            email: email,
                            first_name: result['givenName'],
                            last_name: result['familyName'],
                            imageURL: ['imageUrl'],
                        }).then(function(response){
                            console.log(response);
                            //.log(response.id);
                            console.log(id);
                            //now create a token with the Google ID.
                            //axios.get("https://expmindapp.wpengine.com/wp-json/ggle/v2/token?id="+id, {//I need some kind of JWT Token
                            axios.get("https://explorermindsetapp.com/wp-json/ggle/v2/token?id="+id, {//I need some kind of JWT Token
                            }).then(function(response){
                                let firstname = response['data']['firstName'];
                                //let lastname = response['data']['lastName'];
                                console.log('token');//debug for validating
                                console.log(response);
                                let savetoken = response['data']['token'];
                                let savenicename = response['data']['nicename'];
                                let saveuser = email;
                                let saveemail = email;
                                let saveID = response['data']['claims']['userId'];
                                console.log("id: " + saveID);
                                if (saveToStorage(savetoken,saveuser,saveemail,savenicename,saveID)) {//save account
                                  history.push("/dashboard/" + email);
                                } else {
                                  console.log('Failed to store auth');
                                }
                            }).catch(function(error){
                                console.log("error");
                            }).then(function(){
                            });
                        }).catch(function(error){
                            console.log("error");
                        }).then(function(){
                        });
                        
                    }else{
                        console.log('they exist - create token');
                        let firstname = response['data']['firstName'];
                    //let lastname = response['data']['lastName'];
                            //axios.get("https://expmindapp.wpengine.com/wp-json/ggle/v2/token?id="+id, {//test site
                         
                            axios.get("https://explorermindsetapp.com/wp-json/ggle/v2/token?id="+id, {//live site
                            }).then(function(response){
                              console.log(response);
                                console.log('token');//debug for validating\
                                console.log(response['data']['claims'])
                                let savetoken = response['data']['token'];
                                let savenicename = response['data']['nicename'];
                                let saveuser = email;
                                let saveemail = email;
                                let saveID = response['data']['claims']['userId'];
                                console.log("id: " + saveID);
                                if (saveToStorage(savetoken,saveuser,saveemail,savenicename,saveID)) {//save account
                                  history.push("/dashboard/" + email);
                                } else {
                                  console.log('Failed to store auth');
                                }
                            }).catch(function(error){
                                console.log("error");
                            }).then(function(){
                            });
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .then(function () {
                    // always executed
                });
            }
       }catch(e){
       }
       //end 3rd party if
      }
    }
    const handleLogin = () => {
        if (!email) {
            setMessage("Please enter a valid email");
            setIserror(true);
            return;
        }
        if (validateEmail(email) === false) {
            setMessage("Your email is invalid");
            setIserror(true);
            return;
        }
        if (!password || password.length < 6) {
            setMessage("Please enter your password");
            setIserror(true);
            return;
        }
        //axios version
        //axios.post("https://expmindapp.wpengine.com/wp-json/aam/v1/authenticate", { //test site
        axios.post("https://explorermindsetapp.com/wp-json/aam/v1/authenticate", { //live site
        //axios.post("https://expmindapp.wpengine.com/wp-json/simple-jwt-login/v1/auth", {
            username: email,
            password: password
        })
            .then(function (response) {
                //console.log("success");
                console.log(response);
                let savetoken = response['data']['jwt']['token'];
                let saveuser = response['data']['user']['data']['user_login'];
                let saveemail = response['data']['user']['data']['user_email'];
                let savenicename = response['data']['user']['data']['user_nicename'];
                let saveID = response['data']['user']['data']['ID'];
                if (saveToStorage(savetoken,saveuser,saveemail,savenicename,saveID)) {
                    history.push("/dashboard/" + email);
                } else {
                    console.log('Failed to store auth');
                }
            })
            .catch(error => {
                console.log(error.message);
                setMessage(error.message);
                setIserror(true);
            })
    };
  return (
    <IonPage>
          <IonContent>
       
        <IonAlert
            isOpen={iserror}
            onDidDismiss={() => setIserror(false)}
            cssClass="my-custom-class"
            header={"Error!"}
            message={message}
            buttons={["Dismiss"]}
        />
          <IonAlert
          isOpen={showAgeAlert}
          onDidDismiss={() => setAgeAlert(false)}
          cssClass='my-custom-class'
          header={'Age Check'}
          message={'Are you 13 or over?'}
          buttons={[
            {
              text: 'Yes',
              handler: () => {
                signIn();
              }
            },
            {
              text: 'No',
              handler: () => {
                setRegAlert(true);
              }
            }
          ]}
        />
        <IonAlert
          isOpen={showRegAlert}
          onDidDismiss={() => setRegAlert(false)}
          cssClass='my-custom-class'
          header={'Logged in'}
          message={'Have you already registered?'}
          buttons={[
            {
              text: 'Yes',
              handler: () => {
                signIn();
              }
            },
            {
              text: 'No',
              handler: () => {
                setEmailAlert(true);
              }
            }
          ]}
        />
         <IonAlert
          isOpen={showEmailAlert}
          onDidDismiss={() => setEmailAlert(false)}
          cssClass='my-custom-class'
          header={'Parent'}
          message={'Please enter a parent or guardian email below so they can approve your use of the Explorer Mindset App.'}
          inputs={[
            {
              name: 'parents_email',
              type: 'text',
              placeholder: 'Parents Email'
            },
            {
              name: 'child_email',
              type: 'text',
              placeholder: 'Your Email'
            }
        ]}
          buttons={[
            {
              text: 'Sign Up',
              handler: (alertData) => {
                var parent_email = alertData.parents_email;
                var child_email = alertData.child_email;
                console.log(parent_email !== "");
                if(parent_email !== "" && child_email !== ""){ //they are not blank

                  parent_email = alertData.parents_email;
                  child_email = alertData.child_email;
                
                  if (validateEmail(parent_email) === false) {
                    return false;
                  }else if (validateEmail(child_email) === false) {
                    return false;
                  }else{
                    //fire parent email. 
                    axios.get("https://explorermindsetapp.com/wp-json/ggle/v2/parents?parent_email="+parent_email+"&child_email="+child_email, {//I need some kind of JWT Token
                    
                    //axios.get("https://expmindapp.wpengine.com/wp-json/ggle/v2/parents?parent_email="+parent_email+"&child_email="+child_email, {//I need some kind of JWT Token
                    }).then(function(response){
                        //console.log('parents emailed');//debug for validating
                        console.log(response);
                        signIn();
                        return true;
                    }).catch(function(error){
                        console.log("not able to email");
                        return false;
                    }).then(function(){
                      console.log("done");
                    });
                    
                  }
                }else{
                  return false; //stop from submitting until we can validate the emails 
                }
                
                
                console.log('send an email to the parent email / ' + parent_email + ' sign up using google. / Sign in ' + child_email);
              
                //signIn();
              }
            },
            {
              text: 'Cancel',
              handler: () => {
                console.log('send an email to the parent email / sign up using google. / Sign in');
              }
            },

          ]}
        />
          <IonGrid className="ion-text-center">
                    

                <IonRow className="pagekeep">
                    <IonCol className="logobutton"  size="12" size-sm="5">


                    <IonRow className="logorow">
                      <IonCol>
                        <Logo />
                        
                      </IonCol>
                      </IonRow>
                    <IonRow className="googlerow">
                      <IonCol>
                    
                      <IonButton className="login-button" onClick={() => handleThirdParty('Google')} expand="block" fill="solid">
                      <IonIcon icon={logoGoogle} className="icon"></IonIcon>  Sign in with Google
                        </IonButton>
                        {(function() {
                        if((plat || ipad) && !webapp){//IOS show apple button
                          return(
                            <IonButton className="apple-login-button" onClick={() => handleThirdParty('Apple')} expand="block" fill="solid">
                            <IonIcon icon={logoApple} className="icon"></IonIcon>  Sign in with Apple
                            </IonButton>
                          )
                        }
                        })()}  
                      </IonCol>
                    </IonRow>

                    </IonCol>
                    <IonCol className="or" size="12" size-sm="2"> 


                    <IonRow>
                      <IonCol class="orimage">
                            <IonImg className="horizontal" src="../assets/images/or_horiz_03.png"/>
                            <IonImg className="vertical" src="../assets/images/or_vert_03.png"/>
                      </IonCol>
                    </IonRow>

                    </IonCol>
                    <IonCol className="login" size="12" size-sm="5">


                        <IonRow>
                            <IonCol>
                                <strong>Sign In Manually</strong><p></p>

                                <IonItem>
                                    <IonLabel position="floating"> Email</IonLabel>
                                    <IonInput
                                        type="email"
                                        value={email}
                                        onIonChange={(e) => setEmail(e.detail.value!)}
                                    >
                                    </IonInput>
                                </IonItem>
                            </IonCol>
                        </IonRow>
                    
                        <IonRow>
                            <IonCol>
                                <IonItem>
                                    <IonLabel position="floating"> Password</IonLabel>
                                    <IonInput
                                        type="password"
                                        value={password}
                                        onIonChange={(e) => setPassword(e.detail.value!)}
                                    >
                                    </IonInput>
                                </IonItem>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonCheckbox
                                value="yes"
                                checked={true}/> <IonLabel>Remember Me</IonLabel>
                                
                            </IonCol>
                            <IonCol>
                            <IonButton onClick={handleLogin} class="button fancy-button">Login</IonButton>
                            </IonCol>
                        </IonRow>
                        <IonRow class="centered">
                        <IonButtons>
                            <IonButton routerLink="/register" className="button fancy-button">Register now?</IonButton>
                            
                            <IonButton routerLink="/" onClick={() => window.open('https://explorermindsetapp.com/wp-login.php?action=lostpassword', '_system', 'location=yes')} className="button fancy-button">Forgot Password?</IonButton>
                        </IonButtons>
                        </IonRow>

                    </IonCol>
                </IonRow>
            </IonGrid>
            </IonContent>
            <IonFooter className="homefooter">
                <IonGrid>
                    <IonRow className="bluebar"></IonRow>
                    <IonRow className="greenbar"></IonRow>
                   <IonRow className="brownbar"></IonRow>
                </IonGrid>
            </IonFooter>
    </IonPage>
  );
};

export default Home;
